export const commonConfig = [
  // <!--券卡片 -->
  'coupon-card',

]

export const exemptionConfig = [

]

export const simpleConfig = []

export const refundOfflineDesc = [
  '当您购票后主动对车票进行退改时（含主动退票、改签退原票、高改低退差价等场景），无论部分退款或整单退款，平台均会优先回收您已使用的券优惠，再退还您余下实付票款金额。',
  '举例：如您在滴滴购买2张单张票价为50元的火车票，支付时使用了一张3元火车票优惠券，则您该笔火车票订单的总计实付金额为2*50-3=97元。当您后续主动申请/主动去线下退改其中一张票时，平台会在先扣除您已使用的3元优惠券后，为您退还第一张票实付的47元；如退完第一张票您再申请退第二张票时，平台会将第二张票的全款50元继续退还给您。',
]
